module.exports = __webpack_public_path__ + "img/2023big35.3ba4d4a4.png";